"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _defineProperty2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.function.name.js");
var _emit = _interopRequireDefault(require("./emit"));
var _utils = require("./utils");
var _constant = require("./constant");
var _ActionBar = _interopRequireDefault(require("./components/ActionBar.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'SimpleFlowChart',
  components: (0, _defineProperty2.default)({}, _ActionBar.default.name, _ActionBar.default),
  model: {
    prop: 'data',
    event: 'change'
  },
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    customCreateNode: {
      type: Function
    },
    customCreateConditionBranchNode: {
      type: Function
    },
    beforeDeleteNode: {
      type: Function
    },
    background: {
      type: String,
      default: 'rgba(0, 0, 0, 0.03)'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    nodeTypeList: {
      type: Array
    },
    vertical: {
      type: Boolean,
      default: false
    },
    showScaleBar: {
      type: Boolean,
      default: true
    },
    customCreateNodeId: {
      type: Function
    },
    enableDrag: {
      type: Boolean,
      default: true
    },
    initFit: {
      type: Boolean,
      default: false
    },
    showScrollBar: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      scale: 100,
      showHideDiv: false,
      isMousedown: false,
      mousedownPos: {
        x: 0,
        y: 0
      },
      mousedownScrollPos: {
        x: 0,
        y: 0
      }
    };
  },
  watch: {
    scale: function scale() {
      this.showHideDiv = !this.showHideDiv;
    }
  },
  created: function created() {
    _constant.store.readonly = this.readonly;
    _constant.store.nodeTypeList = this.nodeTypeList;
    _constant.store.vertical = this.vertical;
    _constant.store.customCreateNodeId = this.customCreateNodeId;
    if (this.data.length <= 0) {
      var _this$data;
      (_this$data = this.data).push.apply(_this$data, (0, _toConsumableArray2.default)(_constant.defaultNodeList));
    }
    _emit.default.on('add-node-type-click', this.onAddNodeTypeClick);
    _emit.default.on('delete-node-click', this.onNodeDeleteClick);
    _emit.default.on('add-condition-branch-click', this.onAddConditionBranchClick);
    _emit.default.on('node-content-click', this.onNodeContentClick);
    window.addEventListener('mousemove', this.onMousemove);
    window.addEventListener('mouseup', this.onMouseup);
  },
  mounted: function mounted() {
    if (this.initFit) {
      this.fit();
    }
  },
  beforeDestroy: function beforeDestroy() {
    _emit.default.off('add-node-type-click', this.onAddNodeTypeClick);
    _emit.default.off('delete-node-click', this.onNodeDeleteClick);
    _emit.default.off('add-condition-branch-click', this.onAddConditionBranchClick);
    _emit.default.off('node-content-click', this.onNodeContentClick);
    window.removeEventListener('mousemove', this.onMousemove);
    window.removeEventListener('mouseup', this.onMouseup);
  },
  methods: {
    // 缩放至全部显示
    fit: function fit() {
      var _this = this;
      this.scale = 100;
      this.$nextTick(function () {
        var containerSize = _this.$refs.sfcContainer.getBoundingClientRect();
        var containerRatio = containerSize.width / containerSize.height;
        var contentSize = _this.$refs.sfcContent.getBoundingClientRect();
        var contentRatio = contentSize.width / contentSize.height;
        var w, h;
        if (containerRatio > contentRatio) {
          // 以容器的高为准
          h = containerSize.height;
          w = contentRatio * h;
        } else {
          // 以容器的宽为准
          w = containerSize.width;
          h = w / contentRatio;
        }
        _this.scale = w / contentSize.width * 100;
        console.log(contentSize.width, containerSize.width);
        var x = (contentSize.width - containerSize.width) / 2;
        var y = (contentSize.height - containerSize.height) / 2;
        _this.$refs.sfcContainer.scrollTo(x, y);
      });
    },
    onAddNodeTypeClick: function onAddNodeTypeClick(nodeList, nodeData, type) {
      console.log('1', nodeList);
      console.log('1', nodeData);
      console.log('1', type);
      var newNode = null;
      if (this.customCreateNode) {
        newNode = this.customCreateNode(nodeList, nodeData, type);
      }
      if (!newNode) {
        newNode = (0, _utils.generateNode)(type.type);
      }
      this.addNode(nodeList, nodeData, newNode);
      this.$emit('add-node', newNode);
    },
    addNode: function addNode(nodeList, nodeData, newNode) {
      if (nodeList) {
        var index = this.findNodeIndex(nodeList, nodeData);
        nodeList.splice(index + 1, 0, newNode);
      } else {
        nodeData.nodeList.unshift(newNode);
      }
    },
    onNodeDeleteClick: function onNodeDeleteClick() {
      var _this2 = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (this.beforeDeleteNode) {
        this.beforeDeleteNode.apply(this, args).then(function () {
          _this2.deleteNode.apply(_this2, args);
        });
      } else {
        this.deleteNode.apply(this, args);
        this.$emit('delete-node', args[3]);
      }
    },
    deleteNode: function deleteNode(nodeList, childrenList, belongConditionNodeData, nodeData) {
      if (nodeList) {
        var index = this.findNodeIndex(nodeList, nodeData);
        nodeList.splice(index, 1);
      } else if (childrenList) {
        var _index = this.findNodeIndex(childrenList, nodeData);
        childrenList.splice(_index, 1);
        if (childrenList.length <= 1) {
          this.removeNodeFromData(belongConditionNodeData);
        }
      }
    },
    onAddConditionBranchClick: function onAddConditionBranchClick(nodeData) {
      var newNode = null;
      if (this.customCreateConditionBranchNode) {
        newNode = this.customCreateConditionBranchNode(nodeData);
      }
      if (!newNode) {
        newNode = (0, _utils.generateNode)('normal', '条件', '条件内容');
      }
      nodeData.children.push(newNode);
      this.$emit('add-condition-branch', newNode);
    },
    onNodeContentClick: function onNodeContentClick() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      this.$emit.apply(this, ['node-content-click'].concat(args));
    },
    findNodeIndex: function findNodeIndex(list, node) {
      return list.findIndex(function (item) {
        return item === node;
      });
    },
    removeNodeFromData: function removeNodeFromData(nodeData) {
      var _walk = function walk(arr) {
        for (var i = 0; i < arr.length; i++) {
          var node = arr[i];
          if (node === nodeData) {
            arr.splice(i, 1);
            return true;
          }
          var res = false;
          if (node.children && node.children.length > 0) {
            res = _walk(node.children);
          }
          if (!res && node.nodeList && node.nodeList.length > 0) {
            res = _walk(node.nodeList);
          }
          if (res) {
            break;
          }
        }
      };
      _walk(this.data);
    },
    onMousedown: function onMousedown(e) {
      this.isMousedown = true;
      this.mousedownPos.x = e.clientX;
      this.mousedownPos.y = e.clientY;
      this.mousedownScrollPos.x = this.$refs.sfcContainer.scrollLeft;
      this.mousedownScrollPos.y = this.$refs.sfcContainer.scrollTop;
    },
    onMousemove: function onMousemove(e) {
      if (!this.isMousedown || !this.$refs.sfcContainer || !this.enableDrag) return;
      e.preventDefault();
      var nx = this.mousedownScrollPos.x - (e.clientX - this.mousedownPos.x);
      var ny = this.mousedownScrollPos.y - (e.clientY - this.mousedownPos.y);
      this.$refs.sfcContainer.scrollTo(nx, ny);
    },
    onMouseup: function onMouseup() {
      this.isMousedown = false;
    }
  }
};